/**
 * Event Form Reducer
 * Manages all state related to event creation/editing form
 */

export const eventFormActions = {
    SET_FIELD: 'SET_FIELD',
    SET_VALIDATION: 'SET_VALIDATION',
    SET_DROPDOWN_OPEN: 'SET_DROPDOWN_OPEN',
    RESET_FORM: 'RESET_FORM',
    SET_FROM_EVENT: 'SET_FROM_EVENT',
};

const initialState = {
    // Basic event fields
    eventName: '',
    eventDescription: '',
    eventLocation: '',
    eventOrganizer: '',
    eventAttendees: [],
    externalAttendees: [],
    eventBannerFile: null,
    eventBanner: null,
    isVirtual: false,
    eventMeetingLink: '',
    
    // Date and time
    eventDate: null,
    eventStartTime: '',
    eventEndTime: '',
    startTime: '',
    endTime: '',
    startTimeString: '',
    endTimeString: '',
    isSlotSelected: false,
    
    // Repeat settings
    repeatType: 'does_not_repeat',
    
    // Reminder settings
    reminderMethod: 'popup',
    reminderMinutes: 10,
    
    // Validation states
    eventNameIsValid: false,
    eventDateIsValid: false,
    eventStartTimeIsValid: false,
    eventEndTimeIsValid: false,
    startTimeIsValid: false,
    endTimeIsValid: false,
    repeatTypeIsValid: false,
    reminderMinutesIsValid: false,
    
    // Dropdown states
    repeatTypeDropdownOpen: false,
    organizerDropdownOpen: false,
    reminderMethodDropdownOpen: false,
};

export const eventFormReducer = (state, action) => {
    switch (action.type) {
        case eventFormActions.SET_FIELD:
            return {
                ...state,
                [action.field]: action.value,
            };
        
        case eventFormActions.SET_VALIDATION:
            return {
                ...state,
                [action.field]: action.isValid,
            };
        
        case eventFormActions.SET_DROPDOWN_OPEN:
            return {
                ...state,
                [action.field]: action.isOpen,
            };
        
        case eventFormActions.RESET_FORM:
            return {
                ...initialState,
                startTimeString: action.startTimeString || '',
                endTimeString: action.endTimeString || '',
            };
        
        case eventFormActions.SET_FROM_EVENT:
            return {
                ...state,
                ...action.eventData,
            };
        
        default:
            return state;
    }
};

